import { c as _c } from "react/compiler-runtime";
import { spacing } from '@cc-shopping/ui/theme';
import { Box, type BoxProps } from '@mui/material';
import { CompareQuickFiltersWrapper } from '../CompareQuickFiltersWrapper';
import { useCompareContext } from '../Context';
import { CreditCardsCompareSearch } from './components/Search';
const Filter = props => {
  const $ = _c(7);
  const {
    compareData: t0
  } = useCompareContext();
  const {
    offersByCategory
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = spacing(5);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CreditCardsCompareSearch />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== offersByCategory) {
    t3 = <CompareQuickFiltersWrapper offersByCategory={offersByCategory} />;
    $[2] = offersByCategory;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props || $[5] !== t3) {
    t4 = <Box display="flex" flexDirection="column" alignItems="center" gap={t1} {...props}>{t2}{t3}</Box>;
    $[4] = props;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default Filter;